import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetouttarpradeshbusonrent() {



  const cardData =
  {
    keyword: 'Pune to Uttar Pradesh Bus On Rent ',
    heading: 'Sanavi Travels: Pune to Uttar Pradesh Bus On Rent',
    headingDescription: 'Sanavi Travels offers reliable Pune to Uttar Pradesh Bus on Rent, providing safe, comfortable, and well-managed long-distance transportation for families, pilgrimage groups, corporate teams, educational tours, and large travel groups journeying from Pune to Uttar Pradesh. Our fleet of AC and Non-AC buses ranging from 32, 35, 40, 45, to 50 seaters, along with tempo travellers on request, is well-maintained and equipped with push-back seating, ample legroom, and spacious luggage capacity to ensure a relaxed interstate travel experience. With experienced long-route drivers, flexible one-way and round-trip rental options, transparent pricing, and dedicated trip coordination, Sanavi Travels ensures a smooth, punctual, and hassle-free journey. We offer convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering major Uttar Pradesh destinations such as Lucknow, Varanasi, Ayodhya, Prayagraj, Agra, Mathura, Vrindavan, Noida, and Kanpur. Choose Sanavi Travels for a trusted Pune to Uttar Pradesh bus rental service, delivering comfort, safety, and a dependable long-distance travel experience.',

    top: 'Top Places to Visit in Uttar Pradesh with Sanavi Travels',


"topPlaces": [
  {
    "title": "Agra – Taj Mahal",
    "description": "Agra is home to the iconic Taj Mahal, a UNESCO World Heritage Site and one of the Seven Wonders of the World. Built by Mughal Emperor Shah Jahan in memory of Mumtaz Mahal, the white marble monument symbolizes eternal love. The intricate carvings, symmetrical gardens, and changing hues at sunrise and sunset attract millions of visitors. Agra stands as the crown jewel of Uttar Pradesh’s historical and architectural legacy."
  },
  {
    "title": "Varanasi",
    "description": "Varanasi is one of the oldest continuously inhabited cities in the world and the spiritual capital of India. Located on the banks of the Ganga River, it is famous for its ghats, temples, and the mesmerizing Ganga Aarti. Pilgrims believe that salvation can be attained here. Varanasi represents spirituality, devotion, and timeless Indian culture."
  },
  {
    "title": "Ayodhya",
    "description": "Ayodhya is the sacred birthplace of Lord Rama and one of the most important religious cities in India. The city is deeply connected to the Ramayana and Hindu traditions. Temples, ghats, and spiritual events attract devotees throughout the year. Ayodhya symbolizes faith, devotion, and India’s ancient heritage."
  },
  {
    "title": "Mathura",
    "description": "Mathura is the birthplace of Lord Krishna and a major pilgrimage center in Uttar Pradesh. The city is known for Krishna Janmabhoomi Temple and vibrant celebrations of Janmashtami and Holi. Mathura’s temples and ghats reflect deep devotion and cultural richness. It forms the spiritual heart of the Braj region."
  },
  {
    "title": "Vrindavan",
    "description": "Vrindavan is closely associated with the childhood and divine plays of Lord Krishna. The town is filled with hundreds of temples, including Banke Bihari and ISKCON Temple. Devotional songs, aartis, and festivals create a spiritually charged atmosphere. Vrindavan embodies love, devotion, and Krishna bhakti."
  },
  {
    "title": "Lucknow",
    "description": "Lucknow, the capital of Uttar Pradesh, is renowned for its Nawabi culture, architecture, and cuisine. Landmarks like Bara Imambara, Chota Imambara, and Rumi Darwaza showcase Mughal and Awadhi elegance. The city is famous for kebabs, biryani, and refined etiquette. Lucknow represents cultural grace and historical sophistication."
  },
  {
    "title": "Prayagraj",
    "description": "Prayagraj, formerly Allahabad, is located at the sacred confluence of the Ganga, Yamuna, and mythical Saraswati rivers. It hosts the Kumbh Mela, the largest religious gathering in the world. The city holds immense spiritual and historical importance. Prayagraj symbolizes unity, faith, and sacred traditions."
  },
  {
    "title": "Sarnath",
    "description": "Sarnath is one of the most important Buddhist pilgrimage sites, where Lord Buddha delivered his first sermon. The Dhamek Stupa, Ashoka Pillar, and ancient monasteries reflect its historical significance. Located near Varanasi, Sarnath offers a peaceful and spiritual environment. It represents enlightenment and the spread of Buddhism."
  },
  {
    "title": "Jhansi",
    "description": "Jhansi is a historic city associated with Rani Lakshmibai and India’s First War of Independence in 1857. Jhansi Fort stands as a symbol of bravery and resistance. The city reflects the valiant spirit of Bundelkhand region. Jhansi represents courage, sacrifice, and patriotism."
  },
  {
    "title": "Chitrakoot",
    "description": "Chitrakoot is a sacred town believed to be the place where Lord Rama, Sita, and Lakshmana spent time during their exile. Surrounded by forests, hills, and rivers, it offers a peaceful spiritual retreat. Temples and natural beauty enhance its charm. Chitrakoot blends devotion, mythology, and nature."
  }
]
,





"services": [
    {
      "name": "Pune to Uttar Pradesh Bus On Rent",
      "description": "Pune to Uttar Pradesh Bus On Rent provides comfortable and reliable bus services for long-distance travel from Pune to various destinations in Uttar Pradesh. Ideal for families, groups, and tourists, this service offers spacious seating, well-maintained buses, and professional drivers to ensure a safe and smooth journey."
    },
    {
      "name": "UP Bus Hire from Pune",
      "description": "UP Bus Hire from Pune offers flexible bus rental options for individuals and groups traveling to Uttar Pradesh. Suitable for short or extended tours, the service focuses on comfort, punctuality, and experienced chauffeurs for stress-free interstate travel."
    },
    {
      "name": "AC Bus Pune to UP",
      "description": "AC Bus Pune to UP provides air-conditioned buses for relaxed and comfortable long-distance journeys. Ideal for family travel, group tours, and holiday trips, these buses ensure a cool environment, ample legroom, and smooth highway travel."
    },
    {
      "name": "Luxury Bus UP Trip",
      "description": "Luxury Bus UP Trip offers premium buses with comfortable interiors and modern amenities for an enhanced travel experience. Perfect for luxury holidays, VIP travel, or corporate groups visiting Uttar Pradesh, combining elegance with safety."
    },
    {
      "name": "Family UP Bus Travel",
      "description": "Family UP Bus Travel is designed for families traveling together to Uttar Pradesh. Spacious seating, safe driving practices, and professional chauffeurs ensure a comfortable and enjoyable journey for all age groups."
    },
    {
      "name": "Group Travel UP Bus",
      "description": "Group Travel UP Bus caters to large groups, tour operators, and organizations planning trips to Uttar Pradesh. Well-maintained buses and skilled drivers ensure coordinated travel, timely schedules, and a smooth group journey."
    },
    {
      "name": "Affordable UP Bus Rental",
      "description": "Affordable UP Bus Rental offers budget-friendly bus hire solutions without compromising on safety or comfort. Ideal for cost-conscious travelers, this service provides reliable buses, transparent pricing, and experienced drivers."
    },
    {
      "name": "Chauffeur Driven UP Bus",
      "description": "Chauffeur Driven UP Bus provides professional and experienced drivers for long-distance interstate travel. Passengers can relax while chauffeurs handle routes, traffic, and safety, ensuring a hassle-free journey to Uttar Pradesh."
    },
    {
      "name": "Best UP Bus Service Pune",
      "description": "Best UP Bus Service Pune offers top-quality buses and dependable service for travel from Pune to Uttar Pradesh. Known for comfort, punctuality, and safety, this service is ideal for families, tourists, and group travelers."
    },
    {
      "name": "Pune UP Travel Bus",
      "description": "Pune UP Travel Bus provides dependable and comfortable transport between Pune and Uttar Pradesh. Spacious interiors, luggage-friendly design, and skilled drivers ensure a smooth and stress-free travel experience."
    },
    {
      "name": "Tourist Bus Hire UP",
      "description": "Tourist Bus Hire UP offers buses for sightseeing and tourism across Uttar Pradesh. Ideal for visiting religious sites, heritage destinations, and popular attractions, this service ensures comfortable and organized travel."
    },
    {
      "name": "Long Distance Bus Rental Pune",
      "description": "Long Distance Bus Rental Pune specializes in extended journeys from Pune to distant destinations like Uttar Pradesh. Comfortable buses, professional drivers, and planned routes ensure relaxed and safe long-distance travel."
    },
    {
      "name": "Religious Tour Bus UP",
      "description": "Religious Tour Bus UP provides dedicated bus services for pilgrimage and spiritual tours across Uttar Pradesh. Suitable for temple visits and religious groups, this service focuses on safety, comfort, and well-coordinated travel."
    },
    {
      "name": "Holiday Bus Package UP",
      "description": "Holiday Bus Package UP offers organized bus tours for vacations and leisure travel to Uttar Pradesh. Designed for convenience and comfort, this service is ideal for families, friends, and group holiday planners."
    },
    {
      "name": "Uttar Pradesh Bus Service",
      "description": "Uttar Pradesh Bus Service provides reliable and comfortable buses for complete UP tours and travel needs. With professional chauffeurs, spacious seating, and efficient planning, this service ensures a smooth and memorable travel experience."
    }
  ],
  "tableData": [
    ["Pune to Uttar Pradesh Bus On Rent", "UP Bus Hire from Pune"],
    ["AC Bus Pune to UP", "Luxury Bus UP Trip"],
    ["Family UP Bus Travel", "Group Travel UP Bus"],
    ["Affordable UP Bus Rental", "Chauffeur Driven UP Bus"],
    ["Best UP Bus Service Pune", "Pune UP Travel Bus"],
    ["Tourist Bus Hire UP", "Long Distance Bus Rental Pune"],
    ["Religious Tour Bus UP", "Holiday Bus Package UP"],
    ["Uttar Pradesh Bus Service", "—"]
  ]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Uttar Pradesh Bus On Rent with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable bus rental services from Pune to Uttar Pradesh, ideal for group travel, family trips, religious tours, and long-distance journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and well-maintained buses with comfortable seating and ample space for a smooth Pune to Uttar Pradesh journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Long-Distance Routes",
    "WhyChoosedescription": "Our professional drivers are experienced with Pune to Uttar Pradesh routes, ensuring safe, timely, and hassle-free long-distance travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Pune to Uttar Pradesh bus rentals, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, route planning, and travel-related queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized bus rental plans based on your Pune to Uttar Pradesh travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Uttar Pradesh bus rentals."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus on rent from Pune to Uttar Pradesh?',
    answer: 'Yes, Sanavi Travels offers comfortable and well-maintained buses for group travel from Pune to Uttar Pradesh.'
  },
  {
    question: 'How can I book a Pune to Uttar Pradesh bus with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What type of buses are available for Pune to Uttar Pradesh travel?',
    answer: 'We provide air-conditioned and non-AC buses in various seating capacities suitable for long-distance group travel.'
  },
  {
    question: 'Are drivers included in the bus rental?',
    answer: 'Yes, all bus rentals include experienced and professional drivers familiar with long-distance routes.'
  },
  {
    question: 'Is the Pune to Uttar Pradesh bus service available 24x7?',
    answer: 'Yes, our service is available round the clock for bookings and travel.'
  },
  {
    question: 'Are the buses sanitized before trips?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the Pune to Uttar Pradesh bus rental plan?',
    answer: 'Absolutely. Sanavi Travels offers customized rental plans according to your travel needs.'
  },
  {
    question: 'What payment options are available for bus bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Uttar Pradesh journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Yadav',
    feedback: 'Booked a bus from Pune to Uttar Pradesh with Sanavi Travels. Comfortable bus, experienced driver, and excellent coordination.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Pooja Mishra',
    feedback: 'Very good service for long-distance travel. Clean bus, smooth journey, and helpful support team. Highly recommended!',
    rating: 5
  }
];










































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Uttar Pradesh Bus On Rent - Sanavi Travels",
  "description": "Pune to Uttar Pradesh bus rental service by Sanavi Travels for family trips, group travel, religious tours, and holiday trips. Choose AC and luxury buses for safe, comfortable, and affordable long-distance travel from Pune to Uttar Pradesh.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1625"
  }
};







  return (
    <div>

<Helmet>
  <title>
    Pune to Uttar Pradesh Bus On Rent Starting from ₹55 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Pune to Uttar Pradesh bus rental with Sanavi Travels. AC and luxury buses for family trips, group travel, religious tours, and holiday trips at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/31.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetouttarpradeshbusonrent;